<template>
  <div>
    <new-allMaintainQuartzJob showingPage="allMaintainQuartzJob"></new-allMaintainQuartzJob>
  </div>
</template>

<script>
import infoList from '../../../components/newspaperInfoList.vue' 
/**
 *@ClassName:fullprojectAutoInspecRepoList
 *@Description:全项目自动巡检报事
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-04-16
 */
export default {
  name:'/manage/main.allMaintainQuartzJob',
  components: {
    'new-allMaintainQuartzJob': infoList 
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {
  
},
}
</script>
<style lang='scss'>
 
</style>
